<template>
  <div class="content">
    <div class="container-fluid">
        <div class="row" v-if="true">
          <div class="col-12">
              <div slot="content">
                DUs 

                <b-table striped hover responsive
                    :items="documents" 
                    :fields="columns" 
                >
                <template #cell(index)="row">
                    {{row.index +1}}            
                </template>
                <template #cell(id)="row">
                    <router-link v-if="!row.item.company.isHost" :to="urlWithRedirect('/du/document/'+row.item.id)">{{row.item.id}}</router-link>
                </template>

                </b-table>
                
              </div>
           </div>   
        </div>   
    </div>
  </div>
</template>

<script>

const Business = require('ppe-business')
import common from '../common/pages.js'

export default {
    data () {
      return {
        Catalog : Business.DUCatalog,
        documents : [],
        columns: [
           'index',
          {key:'city',      label:'Ville',    sortable: true, thClass:"col-city"}, 
          {key:'company',   label:'Société',      sortable: true, thClass:"col-company"}, 
          {key:'name',      label:'Nom',     sortable: true, thClass:"col-name"}, 
          {key:'id',        label:'id',   sortable: true, thClass:"col-id"},
          {key:'modified',  label:'Modifié',    sortable: true, thClass:"col-modified"},
          {key:'progress',  label:'Progrès',                  thClass:"col-progress"},
          {key:'status',    label:'Status',     sortable: true, thClass:"col-status"}, 
          {key:'updated',   label:'Mis à jour',     sortable: true, thClass:"col-updated"}, 
          {key:'version',   label:'Version',     sortable: true, thClass:"col-updated"}, 
          ],
      }},
      mounted() {
      this.$http.get('/du/getdocuments')
        .then(response => {
          console.log("/du/getdocuments", response.data)
          this.documents = response.data.documents
        })
        .catch(err => {
            console.error("/du/getdocuments", ""+err)
        })
    },
    methods:{
        ...common.methods,

    }
}

</script>